"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.blogPostUpdateSchema = exports.blogPostCreateSchema = exports.blogPostSchema = void 0;
const zod_1 = require("zod");
const slug_field_1 = require("../slug-field");
// Full DB row schema — updated to match Prisma BlogPost model fields
exports.blogPostSchema = zod_1.z.object({
    id: zod_1.z.string().cuid().optional(),
    title: zod_1.z.string().min(1, "Başlık zorunludur").max(500),
    titleEn: zod_1.z.string().max(500).nullable().optional(),
    slug: (0, slug_field_1.slugField)(500),
    slugEn: (0, slug_field_1.slugEnField)(500),
    excerpt: zod_1.z.string().min(1, "Özet zorunludur"),
    excerptEn: zod_1.z.string().nullable().optional(),
    content: zod_1.z.string().min(1, "İçerik zorunludur"),
    contentEn: zod_1.z.string().nullable().optional(),
    image: zod_1.z.string().max(1000).nullable().optional(),
    tag: zod_1.z.string().max(100).default("Blog"),
    // İlişkili marka slug'ları, virgülle ayrılmış ("hikvision,dahua")
    brands: zod_1.z.string().max(1000).default(""),
    published: zod_1.z.boolean().default(true),
    publishedAt: zod_1.z.string().datetime().optional(),
});
// API verbatim create/update schemas (source of truth: apps/api/src/common/schemas.ts)
exports.blogPostCreateSchema = zod_1.z.object({
    title: zod_1.z.string().min(1).max(500),
    titleEn: zod_1.z.string().max(500).nullable().optional(),
    slug: (0, slug_field_1.slugField)(500),
    slugEn: (0, slug_field_1.slugEnField)(500),
    excerpt: zod_1.z.string().min(1),
    excerptEn: zod_1.z.string().nullable().optional(),
    content: zod_1.z.string().min(1),
    contentEn: zod_1.z.string().nullable().optional(),
    image: zod_1.z.string().max(1000).nullable().optional(),
    tag: zod_1.z.string().max(100).default("Blog"),
    // İlişkili marka slug'ları, virgülle ayrılmış ("hikvision,dahua")
    brands: zod_1.z.string().max(1000).default(""),
    published: zod_1.z.boolean().default(true),
    publishedAt: zod_1.z.string().datetime().optional(),
});
exports.blogPostUpdateSchema = zod_1.z.object({
    id: zod_1.z.string().cuid(),
    title: zod_1.z.string().min(1).max(500).optional(),
    titleEn: zod_1.z.string().max(500).nullable().optional(),
    slug: (0, slug_field_1.slugField)(500).optional(),
    slugEn: (0, slug_field_1.slugEnField)(500),
    excerpt: zod_1.z.string().min(1).optional(),
    excerptEn: zod_1.z.string().nullable().optional(),
    content: zod_1.z.string().min(1).optional(),
    contentEn: zod_1.z.string().nullable().optional(),
    image: zod_1.z.string().max(1000).nullable().optional(),
    tag: zod_1.z.string().max(100).optional(),
    brands: zod_1.z.string().max(1000).optional(),
    published: zod_1.z.boolean().optional(),
    publishedAt: zod_1.z.string().datetime().optional(),
});
//# sourceMappingURL=blog-post.js.map